import { useReprojectionsBuffer } from "@/services/buffer-controller";
import { Computed, observer } from "@legendapp/state/react";
import { Reprojection } from "./reprojection";

export const Reprojections = observer(() => {
  const projectionsBuffer = useReprojectionsBuffer();
  const tracks = projectionsBuffer.getTracks();

  return (
    <Computed>
      {() =>
        tracks.map((track) => <Reprojection key={track} trackId={track} />)
      }
    </Computed>
  );
});
